import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "./../utils/api";
import { toast } from "react-toastify";

// Login thunk
export const login = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await api.post("/auth/admin/login", credentials);
      // Store token from the top-level response field
      localStorage.setItem("token", response.data.token);
      return response.data;
    } catch (error) {
      // Error toasts are handled by API interceptor, so we just pass the error data
      return rejectWithValue(
        error.response?.data || { message: "Login failed" }
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    _id: null,
    email: null,
    name: null,
    phoneNumber: null,
    city: null,
    role: null,
    title: null,
    isActive: false,
    isOnline: false,
    isSubscriper: false, // Added this field from API response
    passwordChangedAt: null,
    credential: null, // Added credential field
    token: localStorage.getItem("token"),
    isAuthenticated: localStorage.getItem("token") ? true : false,
    isLoading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      // Reset all state properties to their initial values
      Object.assign(state, {
        _id: null,
        email: null,
        name: null,
        phoneNumber: null,
        city: null,
        role: null,
        title: null,
        isActive: false,
        isOnline: false,
        isSubscriper: false,
        passwordChangedAt: null,
        credential: null, // Reset credential
        token: null,
        isAuthenticated: false,
        error: null,
      });

      localStorage.removeItem("token");
      toast.info("تم تسجيل الخروج بنجاح");
    },
    clearErrors: (state) => {
      state.error = null;
    },

    // Add this method to manually update user data if needed
    updateUserData: (state, action) => {
      const userData = action.payload.data || action.payload;

      // Directly update all properties that exist in the payload
      Object.keys(userData).forEach((key) => {
        if (state.hasOwnProperty(key)) {
          state[key] = userData[key];
        }
      });

      // Ensure authentication is set if we have a name or id
      if (userData._id || userData.name) {
        state.isAuthenticated = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Login cases
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;

        // Store the token separately (from top level)
        state.token = action.payload.token;
        state.isAuthenticated = true;

        // Extract all user data from nested 'data' object
        const userData = action.payload.data;

        // Update all user properties
        state._id = userData._id;
        state.email = userData.email;
        state.name = userData.name;
        state.phoneNumber = userData.phoneNumber;
        state.city = userData.city;
        state.role = userData.role;
        state.title = userData.title;
        state.isActive = userData.isActive;
        state.isOnline = userData.isOnline;
        state.isSubscriper = userData.isSubscriper; // Added this field
        state.passwordChangedAt = userData.passwordChangedAt;
        state.credential = userData.credential; // Store the credential object

        // Show success message
        toast.success(`مرحباً ${userData.name}`);
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        // No toast here as the API interceptor will handle that
      });
  },
});

export const { logout, clearErrors, updateUserData } = authSlice.actions;
export default authSlice.reducer;
